// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { CrossratesPlan } from './CrossratesPlan';
import { CustomEvent } from '@shared/utils/CustomEvents';
export class CrossratesPlans {
    constructor(dCache) {
        this.UpdateEvent = new CustomEvent();
        this._fCrossratesPlans = {};
        this.DCache = dCache;
    }
    GetPlanById(id) {
        return this._fCrossratesPlans[id] || null;
    }
    Add(message) {
        let plan = this.GetPlanById(message.Id);
        if (!plan) {
            plan = this._fCrossratesPlans[message.Id] = new CrossratesPlan(message.Id, this.DCache);
        }
        plan.Update(message);
        this.UpdateEvent.Raise(plan);
    }
    Clear() {
        this._fCrossratesPlans = {};
    }
}
